/**
 * Whether the help page is offered in the interface (Jira NAV-114).
 *
 * **It is not, for now.** The page was built and shipped in one go (PRD I1,
 * NAV-18) and its wording has never been read by the person who asked for a
 * help section — it went out as a draft and stayed. That matters more here than
 * on most screens: help is the surface a stuck colleague trusts, so a sentence
 * that is nearly right sends them somewhere nearly right, and the tester's ask
 * was that it not be offered until somebody has signed off on what it says.
 *
 * So the two controls that reach it — "Need help?" in the navigation bar and
 * "Help & support" in the account menu — are withdrawn, and **the route stays
 * reachable by URL** so the draft can be read and marked up. The page says so
 * at the top when it is in this state, because somebody arriving on it by link
 * should know what they are looking at.
 *
 * One flag rather than two edits, so the two controls cannot drift apart and
 * re-offering the page is a one-line change. When the wording is agreed: flip
 * this to `true`, delete the notice's copy, and delete this file.
 *
 * Deliberately a constant and not a feature flag in `web_config`. A flag is for
 * something the group turns on and off; this is a state the code is in until a
 * review happens, and putting it in configuration would make "is help offered?"
 * a question about an environment rather than about a document nobody has
 * approved.
 */
export const HELP_PAGE_OFFERED = false;
